import React, { useState } from 'react';
import { X, Send, Pencil, Trash2, Check, Heart } from 'lucide-react';
import { Avatar, RichText } from './shared';
import { currentUser } from '../mock';

let uid = 0;
const seedFor = (post) => [
  { id: `s${uid++}`, name: 'Lisa Park', handle: 'lisap', avatar: post.avatar, text: 'This is absolutely stunning! 😍', time: '2h', mine: false, likes: 12 },
  { id: `s${uid++}`, name: 'David Kim', handle: 'davidk', avatar: post.avatar, text: 'Take me with you next time @' + (post.handle || 'you').replace('@', ''), time: '1h', mine: false, likes: 4 },
];

export default function CommentsSheet({ open, post, onClose, onCountChange }) {
  const [comments, setComments] = useState(() => seedFor(post || {}));
  const [text, setText] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');

  if (!open) return null;

  const sync = (list) => { setComments(list); onCountChange && onCountChange(list.length); };

  const add = () => {
    const t = text.trim();
    if (!t) return;
    const c = { id: `c${Date.now()}`, name: currentUser.name, handle: 'emma', avatar: currentUser.avatar, text: t, time: 'now', mine: true, likes: 0 };
    sync([...comments, c]);
    setText('');
  };
  const saveEdit = (id) => {
    sync(comments.map((c) => (c.id === id ? { ...c, text: editText, edited: true } : c)));
    setEditingId(null); setEditText('');
  };
  const del = (id) => sync(comments.filter((c) => c.id !== id));

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative w-full max-w-[440px] bg-[#0c1420] rounded-t-3xl h-[70%] flex flex-col animate-pop-in" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#141c28]">
          <h3 className="font-display text-base font-bold text-white">Comments · {comments.length}</h3>
          <button onClick={onClose}><X size={22} className="text-[#8b95a5]" /></button>
        </div>

        <div className="flex-1 overflow-y-auto app-scroll px-4 py-3 space-y-4">
          {comments.map((c) => (
            <div key={c.id} className="flex gap-3">
              <Avatar src={c.avatar} size={36} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[13px] font-semibold text-white">{c.name}</span>
                  <span className="text-[11px] text-[#5c6675]">{c.time}{c.edited ? ' · edited' : ''}</span>
                </div>
                {editingId === c.id ? (
                  <div className="flex items-center gap-2 mt-1">
                    <input
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      className="flex-1 bg-[#0a0f18] rounded-lg px-3 py-1.5 text-[13px] text-white outline-none ring-1 ring-[#2f8bff]"
                      autoFocus
                    />
                    <button onClick={() => saveEdit(c.id)} className="text-[#22c55e]"><Check size={18} /></button>
                  </div>
                ) : (
                  <RichText text={c.text} className="text-[13px] text-[#dbe1ea] leading-snug block mt-0.5" />
                )}
                {c.mine && editingId !== c.id && (
                  <div className="flex items-center gap-3 mt-1.5">
                    <button onClick={() => { setEditingId(c.id); setEditText(c.text); }} className="flex items-center gap-1 text-[11px] text-[#8b95a5]"><Pencil size={12} /> Edit</button>
                    <button onClick={() => del(c.id)} className="flex items-center gap-1 text-[11px] text-[#f43f5e]"><Trash2 size={12} /> Delete</button>
                  </div>
                )}
              </div>
              <button className="text-[#5c6675] self-start"><Heart size={14} /></button>
            </div>
          ))}
        </div>

        <div className="px-3 py-3 border-t border-[#141c28] flex items-center gap-2">
          <Avatar src={currentUser.avatar} size={34} />
          <div className="flex-1 flex items-center gap-2 bg-[#0f1622] rounded-full px-4 py-2 ring-1 ring-[#1c2634]">
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && add()}
              placeholder="Add a comment... use @ to mention"
              className="flex-1 bg-transparent text-[13px] text-white placeholder:text-[#5c6675] outline-none"
            />
          </div>
          <button onClick={add} className="w-10 h-10 rounded-full bg-[#2f8bff] flex items-center justify-center active:scale-90 transition-transform">
            <Send size={16} className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}
